export const isMedicalSegment = (segment = {}) => {
	const title = (segment?.title || "").toLowerCase().trim();
	return title === "medical" || title === "family doctor" || title === "family physician";
};
export const isPharmacySegment = (segment = {}) => (segment?.title || "").toLowerCase() === "pharmacy";
export const isLaboratoryAndImagingSegment = (segment = {}) =>
	["private hc services", "lab/imaging"].includes((segment?.title || "").toLowerCase());
export const isPatientSegment = (segment = {}) => (segment?.title || "").toLowerCase() === "patient";
export const getMedicalSegmentFromSegments = (segments = []) => [...(segments || [])].find(isMedicalSegment);
export const getPharmacySegmentFromSegments = (segments = []) => [...(segments || [])].find(isPharmacySegment);
export const getLaboratoryAndImagingSegmentFromSegments = (segments = []) =>
	[...(segments || [])].find(isLaboratoryAndImagingSegment);
export const getPatientSegmentFromSegments = (segments = []) => [...(segments || [])].find(isPatientSegment);
